/* unplugin-vue-components disabled */import script from "./LayoutView.vue?vue&type=script&lang=ts&setup=true"
export * from "./LayoutView.vue?vue&type=script&lang=ts&setup=true"

import "./LayoutView.vue?vue&type=style&index=0&id=43775fca&lang=scss"

const __exports__ = script;

export default __exports__